export default __webpack_public_path__ + "static/media/Initiate's Leggings of the Eternal Eclipse.1e5d78a9.jpg";